import { FC } from 'react'
import { FLOWCODE_ROOT } from '@dtx-company/true-common/src/constants/root'

const BASE_URL = FLOWCODE_ROOT

const getImageLink = (filename: string): string => {
  return `${BASE_URL}/static/images/how-to-schema/${filename}`
}

export const HowToSchema: FC = () => {
  return (
    <script
      data-testid="how-to-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `
          {
            "@context": "https://schema.org/", 
            "@type": "HowTo", 
            "name": "How to create a free QR code",
            "description": "Learn how you can create a free QR code within 60 seconds, in 3 easy steps.",
            "totalTime": "PT1M",
            "estimatedCost": {
              "@type": "MonetaryAmount",
              "currency": "USD",
              "value": "0"
            },
            "step": [{
              "@type": "HowToStep",
              "text": "Choose your destination. You can choose from website, social media, image or other files, Google doc, tik tok, wifi, Venmo, email or phone number.",
              "name": "Destination type",
              "image": "${getImageLink('Still_Flowcode_1080x1080_DestinationType.png')}"
            },{
              "@type": "HowToStep",
              "text": "In the fields below, provide all the details that are asked about your URL, link, file, phone number, wifi network or email id.",
              "name": "Provide the details",
              "image": "${getImageLink('Still_Flowcode_1080x1080_EnterDestination.png')}"
            },{
              "@type": "HowToStep",
              "text": "Download your QR code and share it.",
              "name": "Download your code",
              "image": "${getImageLink('Still_Flowcode_1080x1080_DownloadFlowcode.png ')}"
            }]    
          }
  
         `
      }}
    />
  )
}
